import * as React from 'react';
import { Helmet } from 'react-helmet';

import Carousel from '../components/Carousel';
import Categories from '../components/Categories';
import Featured from '../components/Featured';
import { renderOrganization as renderOrganizationLDJSON } from '../helpers/ld_json';

const Home = () => (
  <main>
    <Helmet>
      <title>{process.env.REACT_APP_PROJECT_NAME} – Scuba Diving Gear and Equipment</title>
      {renderOrganizationLDJSON()}
    </Helmet>
    <div className="container">
      <div className="row mainRow">
        <Categories />
        <div className="contentWrapper">
          <Carousel />
          <Featured />
        </div>
      </div>
    </div>
  </main>
);

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home.tsx